import { APP_LABEL_EN } from "./en";

export const APP_LABEL = {
    en: APP_LABEL_EN
}

export const CURRENT_APP_LANGUAGE = 'en'